/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ share: NonNullable<unknown> }} Consumption_Unallocated_AlertInputs */



/**
* | output |
* | --- |
* | "{share} of the consumption escapes the sub-meters: a missing sub-meter, network losses or a faulty meter can explain it." |
*
* @param {Consumption_Unallocated_AlertInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const consumption_unallocated_alert = /** @type {((inputs: Consumption_Unallocated_AlertInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Consumption_Unallocated_AlertInputs, { locale?: "fr" | "en" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ (`${i?.share} of the consumption escapes the sub-meters: a missing sub-meter, network losses or a faulty meter can explain it.`)
	return /** @type {LocalizedString} */ (`${i?.share} de la consommation échappe aux sous-compteurs : un sous-compteur manquant, des pertes réseau ou un compteur défectueux peuvent l'expliquer.`)
});